import styled from '@emotion/styled';
import { useContext } from 'react';
import { TextField, FormControl, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid';

import { TierSelectionContext } from 'account/components/CreateAccountModal/TierSelectionContext';

/*
  The account's feature Tier (BT-9734). A Tier is a named recipe of features (bt_feature_tier);
  applying it on the backend enables that set for the new account. Rendered on BOTH Step-2
  variants (billed details + unbilled). Required — every account has a tier.

  This is a controlled consumer of TierSelectionContext: the selection and the tier list live in
  the wizard's stable Model component (see TierSelectionContext) so a chosen tier survives the
  Back→Next remount of the billed details step. The surrounding form is otherwise read via
  serializeFormData on submit, but the tier is read directly from the lifted state.
*/

const GridContainer = styled(Grid)`
  margin-bottom: 16px;
`;

const FieldLabel = styled(Grid)`
  font-weight: bold;
  font-size: 14px;
`;

function TierSelectField() {
  const {
    tiers, selectedTierId, setSelectedTierId, isLoading,
  } = useContext(TierSelectionContext);

  return (
    <GridContainer item xs={12} md={6}>
      <FormControl fullWidth>
        <Grid container alignItems="center" spacing={2}>
          <FieldLabel item xs={12} sm={3}>Tier:</FieldLabel>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              name="feature_tier_id"
              fullWidth
              size="small"
              required
              value={selectedTierId}
              onChange={(e) => setSelectedTierId(e.target.value)}
              disabled={isLoading || tiers.length === 0}
              helperText="Determines which features are enabled for the account."
            >
              {tiers.map((tier) => (
                <MenuItem key={tier.tier_id} value={String(tier.tier_id)}>
                  {tier.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </FormControl>
    </GridContainer>
  );
}

export default TierSelectField;
